import { Component, OnInit } from '@angular/core';
import { AppInsightsService } from '@sb-tools/typescript/services/app-insights.service';
import { RouterOutlet } from '@angular/router';
import { SimpleNotificationsModule } from 'angular2-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, SimpleNotificationsModule],
})
export class AppComponent implements OnInit {
    constructor(private appInsightsService: AppInsightsService) {}

    ngOnInit() {
        this.appInsightsService.init();
    }
}
